import { render, staticRenderFns } from "./CouponsOnProducts.vue?vue&type=template&id=71814866"
import script from "./CouponsOnProducts.vue?vue&type=script&lang=js"
export * from "./CouponsOnProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports